import React from 'react';
import { Github, Linkedin, Mail } from 'lucide-react';
import '../styles/footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const socialLinks = [
    {
      icon: <Github size={20} />,
      label: 'GitHub',
      url: 'https://github.com/Naveenkm07',
    },
    {
      icon: <Linkedin size={20} />,
      label: 'LinkedIn',
      url: 'https://www.linkedin.com/in/naveenkm07/',
    },
    {
      icon: <Mail size={20} />,
      label: 'Email',
      url: 'mailto:kmnaveenkm85@gmail.com',
    },
  ];

  const quickLinks = [
    { label: 'About', href: '#about' },
    { label: 'Skills', href: '#skills' },
    { label: 'Projects', href: '#projects' },
    { label: 'Experience', href: '#experience' },
    { label: 'Contact', href: '#contact' },
  ];

  const scrollToSection = (e, href) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section">
            <h3 className="footer-title">Naveen Kumar K M</h3>
            <p className="footer-description">
              Computer Science Engineering Student passionate about building
              innovative software solutions and intelligent systems.
            </p>
          </div>

          <div className="footer-section">
            <h4 className="footer-heading">Quick Links</h4>
            <div className="footer-links">
              {quickLinks.map((link, index) => (
                <a
                  key={index}
                  href={link.href}
                  onClick={(e) => scrollToSection(e, link.href)}
                  className="footer-link"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div className="footer-section">
            <h4 className="footer-heading">Connect</h4>
            <div className="footer-social">
              {socialLinks.map((social, index) => {
                const isMailto =
                  typeof social.url === 'string' && social.url.startsWith('mailto:');

                return (
                  <a
                    key={index}
                    href={social.url}
                    {...(!isMailto
                      ? { target: '_blank', rel: 'noopener noreferrer' }
                      : {})}
                    className="footer-social-link"
                    aria-label={social.label}
                  >
                    {social.icon}
                  </a>
                );
              })}
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="footer-copyright">
            © {currentYear} Naveen Kumar K M. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
